import React from "react";
import classnames from "classnames";
import { TrashedItemMenu } from "../LeftBar/TrashedItemMenu";
import SVG from "react-inlinesvg";

export function DeletedDocumentListItem(props) {
  const active = !props.trashedItem && props.documentId === props.item.id;

  const handleRestore = async () => {
    await props.project.undeleteDocument(props.item.id);
    props.setDocumentId(props.contents[0].id);
  };

  return (
    <li
      className={classnames("document-list-item trashed", { active })}
    >
      <button
        aria-label={`Select deleted document: ${props.title}`}
        onClick={(e) => {
          props.setDocumentId(props.item.id);
          props.updateTitle(props.editingTitle, props.newTitle);
        }}
        className={classnames("document-label use-component-styles", {
          untitled: props.untitled,
        })}
      >
        <SVG
          src="/assets/document.svg"
          className="document-icon"
          aria-hidden="true"
        />
        <pre>{props.title}</pre>
      </button>
      <TrashedItemMenu handleRestore={handleRestore} />
    </li>
  );
}
